import { useState } from "react";
import { useSelector } from "react-redux";
import {
  setSelectedAsset,
  setSelectedLastUpdatedDate,
  setSelectedStatus,
} from "../../../../../features/dataAccuracySlice";
import { useDispatch } from "react-redux";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { getSiteInfo } from "../../../../../utils/helpers";
import { selectUserWebsitePermissions } from "../../../../../features/userSlice";

const TaskNameDAFilter = () => {
  const {
    tasksByTaskStructureSharedUid,
    selectedAsset,
    selectedStatus,
    selectedLastUpdatedDate,
  } = useSelector((state: any) => state.dataAccuracy);
  const dispatch = useDispatch();
  const [searchAsset, setSearchAsset] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const allWebsites = useSelector(selectUserWebsitePermissions);
  function appendSiteNameToTasks(tasks: any[], websites: any[]): any[] {
    return tasks.map((task) => {
      const siteName = getSiteInfo(websites, task.website_shared_uid);

      return {
        ...task,
        site_name: siteName || null, // add new field
      };
    });
  }

  const updatedTasks = appendSiteNameToTasks(
    tasksByTaskStructureSharedUid || [],
    allWebsites || [] // your website data array
  );

  const filterConfig = [
    {
      key: "Asset",
      label: "Select Asset",
      searchTerm: searchStatus,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchStatus(e.target.value),
      selectedOption: selectedAsset,
      filterName: "site_name",
      data: updatedTasks,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedAsset(updatedSelection)),
      count: selectedAsset && selectedAsset.length,
      colorSelected:
        selectedAsset !== null && selectedAsset.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Status",
      label: "Select Status",
      searchTerm: searchAsset,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAsset(e.target.value),
      selectedOption: selectedStatus,
      filterName: "current_status",
      data: updatedTasks,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedStatus(updatedSelection)),
      count: selectedStatus && selectedStatus.length,
      colorSelected:
        selectedStatus !== null && selectedStatus.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Last Updated",
      label: "Last Updated At",
      isDateRangeFilter: true,
      selectedOption: selectedLastUpdatedDate,
      filterName: "current_status",
      data: updatedTasks,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedLastUpdatedDate(updatedSelection)),
      count: selectedLastUpdatedDate && selectedLastUpdatedDate.length - 1,
      colorSelected:
        selectedLastUpdatedDate !== null && selectedLastUpdatedDate.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: false,
    },
  ];
  const clearFilters = () => {
    dispatch(setSelectedAsset([]));
    setSearchAsset("");
    dispatch(setSelectedStatus([]));
    setSearchStatus("");
    dispatch(setSelectedLastUpdatedDate([]));
  };
  return (
    <>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </>
  );
};
export default TaskNameDAFilter;
